/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WarehouseStockByAgreemntResponse } from '../../models/warehouse-stock-by-agreemnt-response';

export interface WarehouseControllerStockFromWarehouseStockActualByAgreement$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  office_id?: number;
  stock_type?: number;
  query?: string;
  name?: string;
  code_internal?: string;
  code_supplier?: string;
  brand?: string;
  part_number?: string;
  code_ean?: string;
  desc_short?: string;
  order_by?: string;
  order_direction?: string;
  hide_zero_stock?: boolean;

/**
 * Se true, la lista comprende anche le sedi di sistema (guasti, RAEE, smarriti), escluse di default
 */
  include_special?: boolean;
  related_agreement_id?: number;
  agreement_product_id?: number;
  serialized?: boolean;
}

export function warehouseControllerStockFromWarehouseStockActualByAgreement(http: HttpClient, rootUrl: string, params: WarehouseControllerStockFromWarehouseStockActualByAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerStockFromWarehouseStockActualByAgreement.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('office_id', params.office_id, {});
    rb.query('stock_type', params.stock_type, {});
    rb.query('query', params.query, {});
    rb.query('name', params.name, {});
    rb.query('code_internal', params.code_internal, {});
    rb.query('code_supplier', params.code_supplier, {});
    rb.query('brand', params.brand, {});
    rb.query('part_number', params.part_number, {});
    rb.query('code_ean', params.code_ean, {});
    rb.query('desc_short', params.desc_short, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
    rb.query('hide_zero_stock', params.hide_zero_stock, {});
    rb.query('include_special', params.include_special, {});
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('agreement_product_id', params.agreement_product_id, {});
    rb.query('serialized', params.serialized, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WarehouseStockByAgreemntResponse;
      }>;
    })
  );
}

warehouseControllerStockFromWarehouseStockActualByAgreement.PATH = '/warehouse/stock-from-warehouse_stock_actual-by-agreement';
